import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { Switch } from 'react-router-dom'
import { useAppDispatch, useEffectOnce } from 'Src/hooks'
import { filtersSlice, LazyRoute, PAGE_SLUG, SocketChannel, socketSlice } from 'Modules'
import { userSlice } from 'Pages/user'

const UserListLazy = lazy(() => import('Pages/user/components/desktop/UserList/index'))
const UserFormLazy = lazy(() => import('Pages/user/components/desktop/UserForm/index'))

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
	subscribeChannels: socketSlice.actions.subscribeChannels,
	unSubscribeChannels: socketSlice.actions.unSubscribeChannels,
	clearAll: userSlice.actions.clearAll,
}

export const DesktopUserRoutes = () => {
	const { clearFilters, subscribeChannels, unSubscribeChannels, clearAll } = useAppDispatch(actions)
	useEffectOnce(() => {
		subscribeChannels([SocketChannel.LEAD_CHANNEL])
		return () => {
			unSubscribeChannels([SocketChannel.LEAD_CHANNEL])
			clearFilters(PAGE_SLUG.USER)
			clearAll()
		}
	})

	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.user.index}
				lazyComponent={UserListLazy}
				key={FrontUrls.user.index}
			/>
			<LazyRoute
				exact
				path={FrontUrls.user.create}
				lazyComponent={UserFormLazy}
				key={FrontUrls.user.create}
			/>
			<LazyRoute
				exact
				path={FrontUrls.user.edit}
				lazyComponent={UserFormLazy}
				key={FrontUrls.user.edit}
			/>
		</Switch>
	)
}
